import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function StickyHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  useEffect(() => {
    return scrollY.onChange(latest => {
      setIsScrolled(latest > 50);
    });
  }, [scrollY]);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A0A0A]/90 backdrop-blur-md py-3 shadow-lg border-b border-white/5' : 'bg-transparent py-5'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-137">
        {/* Logo */}
        <div className="flex items-center" data-id="element-138">
          <img src="https://cdn.magicpatterns.com/uploads/dKYFCgZbhFMXzoXJTgVhUs/Logo_18_metodos.jpg" alt="18 Métodos Logo" className="h-10 w-auto object-contain" data-id="element-139" />
        </div>

        {/* Desktop Info */}
        <div className="hidden md:flex flex-col items-center text-center" data-id="element-140">
          <span className="text-[#FAF7F2] font-serif text-lg tracking-wide" data-id="element-141">
            Inmersión Pareja: 18 Métodos
          </span>
          <span className="text-[#C5A55A] text-xs uppercase tracking-widest" data-id="element-142">
            Jueves 12 de febrero · En vivo por Zoom · 10 pm Argentina
          </span>
        </div>

        {/* CTA */}
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-[#B91C1C] hover:bg-[#991b1b] text-white px-6 py-2 rounded-sm font-medium text-sm transition-all duration-300 shadow-[0_0_15px_rgba(185,28,28,0.3)] hover:shadow-[0_0_25px_rgba(185,28,28,0.5)] hover:scale-105" data-id="element-143">
          Reservar cupo
        </button>
      </div>
    </motion.header>;
}